import axios from 'axios';

export const getGraphService = async (deviceId, graphType) => {
  const response = await axios.get(`/live-graph?device_mac=${deviceId}&graph_type=${graphType}`);
  return response.data;
};
